import { MDBBtn } from "mdb-react-ui-kit";
import SmileRed from "../images/SmileRed.svg";

const Navbar = () => {
  return (
    <div>
      <div className="sticky-thc d-flex flex-row align-items-center justify-content-between px-2">
        <div className="text-start">
          <img
            src={SmileRed}
            alt="Digikala"
            style={{
              height: "8px",
              marginRight: "8px",
              marginLeft: "5px",
            }}
          />
          <span>Annual Report 2021-22</span>
        </div>
        <a
          target="_blank"
          rel="noreferrer"
          href={process.env.PUBLIC_URL + "/DigikalaAnualReport2122EN.pdf"}
        >
          <MDBBtn color="info" className="px-3 py-2 btn-filled small-btn">
            Full Version
          </MDBBtn>
        </a>
      </div>
    </div>
  );
};

export default Navbar;
